import request from '@/plugin/axios'

export function subCampProductDetail(subCampProductBizRecId) {
  return request({
    url: '/api/subCampProductDetail/' + subCampProductBizRecId,
    method: 'get'
  })
}